// src/components/layout/MobileBottomNav.jsx
import React, { useState, useEffect } from "react";
import { Paper, BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { Dashboard, Print, History, Menu } from "@mui/icons-material"; // changed MoreHoriz -> Menu

const MobileBottomNav = () => {
  const [value, setValue] = useState("dashboard");
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: "Dashboard", value: "dashboard", icon: <Dashboard />, link: "/" },
    { label: "Requests", value: "print", icon: <Print />, link: "/requests" },
    { label: "History", value: "history", icon: <History />, link: "/history" },
    { label: "More", value: "more", icon: <Menu />, link: "/more" }, // navigate to /more
  ];

  // Sync tab with URL
  useEffect(() => {
    const activeItem = navItems.find((item) => item.link && location.pathname === item.link);
    if (activeItem) setValue(activeItem.value);
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const item = navItems.find((nav) => nav.value === newValue);
    if (item?.link) navigate(item.link);
  };

  if (location.pathname === "/login") return null;

  return (
    <Paper
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1100 }}
      elevation={3}
    >
      <BottomNavigation value={value} onChange={handleChange}>
        {navItems.map((item) => (
          <BottomNavigationAction
            key={item.value}
            label={item.label}
            value={item.value}
            icon={item.icon}
            sx={{
              "& .MuiBottomNavigationAction-label": {
                transition: "0.3s",
              },
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;
